// Build-time env validation. Imports of `env` from anywhere in src/
// trigger this file once on bundle init; missing required vars throw a
// loud error at module evaluation so a misconfigured deploy crashes
// immediately instead of silently shipping a broken bundle.
//
// Required-vs-optional split per spec §13.4.1:
// - VITE_API_URL, VITE_WS_URL, VITE_MARKETING_ORIGIN — required, build fails fast.
// - VITE_GIT_SHA, VITE_SENTRY_ENVIRONMENT — required, defaults supplied.
// - VITE_SENTRY_DSN, VITE_STRIPE_PUBLISHABLE_KEY — optional (empty disables).

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `[env] Required build-time variable ${name} is unset. ` +
        `Set it in .env (dev) or pass via build arg (compose). ` +
        `See spec §13.4.1.`,
    );
  }
  return value;
}

export const env = {
  apiUrl: required("VITE_API_URL", import.meta.env.VITE_API_URL),
  wsUrl: required("VITE_WS_URL", import.meta.env.VITE_WS_URL),
  marketingOrigin: required(
    "VITE_MARKETING_ORIGIN",
    import.meta.env.VITE_MARKETING_ORIGIN,
  ).replace(/\/$/, ""),
  gitSha: import.meta.env.VITE_GIT_SHA ?? "dev",
  sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "development",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "",
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? "",
} as const;
